export default __webpack_public_path__ + "static/media/IMG_1108.3b4589ea.JPG";